import { api } from '../../api'

export const postUpdate = async (data: {
  id: string
  email: string
  first_name: string
  last_name: string
  phone: string
  location: string
  city: string
  country: string
  timezone: string
}) => {
  const res = await api.put('user/profile/', data)
  return res.data
}

export const getProfileDetails = async () => {
  const res = await api.get('user/profile/')
  return res.data
}

export const putProfileNotifications = async (notifications_settings: {
  investigation_created?: boolean
  investigation_file_created?: boolean
  investigation_comment_created?: boolean
  task_keyword_scheduled?: boolean
  task_image_scheduled?: boolean
  task_keyword_failure?: boolean
  task_image_failure?: boolean
  task_keyword_timeout?: boolean
  task_image_timeout?: boolean
  task_keyword_success?: boolean
  task_image_success?: boolean
  task_keyword_expired?: boolean
  task_image_expired?: boolean
  task_keyword_updated?: boolean
  task_image_updated?: boolean
  screenshot_scheduled?: boolean
  compliancy_check_scheduled?: boolean
  screenshot_deleted?: boolean
  item_updated?: boolean
  member_updated?: boolean
  brand_updated?: boolean
  platform_updated?: boolean
  platform_created?: boolean
  item_field_changed?: boolean
  saw_processed?: boolean
  saw_updated?: boolean
  saw_items_imported?: boolean
  saw_late_notice?: boolean
  ticket_assigned?: boolean
  ticket_updated?: boolean
  ticket_deleted?: boolean
  ticket_commented?: boolean
  ticket_due?: boolean
  email_pending_member_review?: boolean
  email_notification_summary?: boolean
  email_low_token_balance?: boolean
  push_enabled?: boolean
}) => {
  const res = await api.put('user/profile/', { notifications_settings })
  return res.data
}
export const postAvatar = async (data: { avatar: File | null }) => {
  const formData = new FormData()

  formData.append('avatar', data?.avatar ?? '')

  const res = await api.put('user/avatar/', formData)
  return res.data
}
